export namespace MfaActions {
    export class GetSettings {
        public static readonly type = "[Mfa] GetSettings";
    }

    export class BeginSetup {
        public static readonly type = "[Mfa] BeginSetup";
    }

    export class BeginSetupForUser {
        public static readonly type = "[Mfa] BeginSetupForUser";
        public constructor(public userId: string) {}
    }

    export class ConfirmSetup {
        public static readonly type = "[Mfa] ConfirmSetup";
        public constructor(public code: string) {}
    }

    export class ConfirmSetupForUser {
        public static readonly type = "[Mfa] ConfirmSetupForUser";
        public constructor(public code: string, public userId: string) {}
    }

    export class VerifyMfaCode {
        public static readonly type = "[Mfa] VerifyMfaCode";
        public constructor(public userId: string, public code: string) {}
    }

    export class Disable {
        public static readonly type = "[Mfa] Disable";
        public constructor(public userId: string, public code: string) {}
    }

    export class CheckRequiresSetup {
        public static readonly type = "[Mfa] CheckRequiresSetup";
    }
}
